import type { LifecycleStatus } from '../types';

/** FR labels + pill variants for the asset lifecycle stages (order = the journey). */
export const LIFECYCLE_META: Record<LifecycleStatus, { label: string; className: string }> = {
  in_stock: { label: 'En stock', className: 'pill-gray' },
  testing: { label: 'En test', className: 'pill-amber' },
  in_transit: { label: 'En livraison', className: 'pill-sky' },
  installed: { label: 'Installee', className: 'pill-indigo' },
  in_service: { label: 'En service', className: 'pill-green' },
  in_maintenance: { label: 'En maintenance', className: 'pill-red' },
  suspended: { label: 'Suspendue', className: 'pill-orange' },
  decommissioned: { label: 'Retiree', className: 'pill-gray' },
};

export const LIFECYCLE_ORDER: LifecycleStatus[] = [
  'in_stock',
  'testing',
  'in_transit',
  'installed',
  'in_service',
  'in_maintenance',
  'suspended',
  'decommissioned',
];

export function lifecycleLabel(status: string | null | undefined): string {
  if (!status) return '-';
  return LIFECYCLE_META[status as LifecycleStatus]?.label ?? status;
}

/** Pill à dot pour une étape du cycle de vie. "-" quand l'env n'est pas migré. */
export function LifecycleBadge({ status }: { readonly status: string | null | undefined }) {
  if (!status) return <span className="t-faint">-</span>;
  const meta = LIFECYCLE_META[status as LifecycleStatus];
  return (
    <span className={`pill ${meta?.className ?? 'pill-gray'}`}>
      <span className="pill-dot" />
      {meta?.label ?? status}
    </span>
  );
}
